<template>
    <div>
        <b-modal
            id="modal-customer-user"
            :title="userModel.id ? 'Edit User' : 'New User'"
            @ok="onSubmit"
        >
            <template #default>
                <b-form>
                    <b-form-group
                        id="input-group-1"
                        label="Email address:"
                        label-for="input-1"
                        label-cols-md="3"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="userModel.email"
                            type="email"
                            placeholder="Enter email"
                            required
                            :disabled="!!userModel.id"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-2"
                        label="First Name:"
                        label-for="input-2"
                        label-cols-md="3"
                    >
                        <b-form-input
                            id="input-2"
                            v-model="userModel.first_name"
                            placeholder="Enter First Name"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-last-name"
                        label="Last Name:"
                        label-for="input-last-name"
                        label-cols-md="3"
                    >
                        <b-form-input
                            id="input-last-name"
                            v-model="userModel.last_name"
                            placeholder="Enter Last Name"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <!--  <b-form-group
                        id="input-group-password"
                        label="Password:"
                        label-for="input-password"
                        label-cols-md="3"
                        :state="
                            !userModel.password ||
                            userModel.password.length >= 5
                        "
                    >
                        <b-form-input
                            id="input-password"
                            v-model="userModel.password"
                            type="password"
                            placeholder="Enter New Password"
                            required
                        ></b-form-input>
                    </b-form-group> -->

                    <b-form-group
                        id="input-group-remarks"
                        label="Remarks:"
                        label-for="input-remarks"
                        label-cols-md="3"
                    >
                        <b-form-textarea
                            id="input-remarks"
                            v-model="userModel.remarks"
                            placeholder="Enter Remarks"
                            required
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </b-form>
            </template>
            <template #modal-footer="{ ok, cancel }">
                <b-button-group size="sm">
                    <b-button
                        :disabled="loading"
                        variant="success"
                        v-if="
                            (!!userModel.id && hasPermissionUpdate) ||
                            (!userModel.id && hasPermissionCreate)
                        "
                        @click="ok()"
                    >
                        <b-spinner
                            v-show="loading"
                            variant="primary"
                            label="Spinning"
                        ></b-spinner>
                        <span v-show="!loading">{{
                            `${userModel.id ? 'Update User' : 'Create User'}`
                        }}</span>
                    </b-button>
                    <b-button
                        v-if="!!userModel.id && hasPermissionDelete"
                        variant="danger"
                        @click="deleteUser(userModel.id)"
                    >
                        Delete User
                    </b-button>
                    <b-button variant="warning" @click="cancel()">
                        Cancel
                    </b-button>
                </b-button-group>
            </template>
        </b-modal>

        <b-button
            size="sm"
            class="mr-2"
            @click="viewCustomer()"
            v-if="hasPermissionCreate"
            >Add User</b-button
        >

        <b-table striped hover :items="users" :fields="fields">
            <template #cell(id)="{ item }">
                <b-button
                    size="sm"
                    class="mr-2"
                    @click="viewCustomer(item)"
                    variant="primary"
                    v-if="hasPermissionDelete"
                >
                    View
                </b-button>
            </template>
        </b-table>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
const userModel = {
    first_name: null,
    last_name: null,
    email: null,
    id: null,
    remarks: null,
}
export default {
    name: 'customers-users',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        fields: [{ label: '', key: 'id' }, 'first_name', 'last_name', 'email'],
        userModel,
        loading: false,
        settings: {},
    }),
    props: ['customer_id'],
    computed: {
        users() {
            return this.$store.getters['customers/customerUsers']
        },
    },

    async mounted() {},

    methods: {
        viewCustomer(data) {
            this.userModel = data || userModel
            this.$bvModal.show('modal-customer-user')
        },

        async onSubmit(event) {
            try {
                event.preventDefault()
                const { customer_id, userModel: data } = this
                const isNew = !data.id
                console.log('data', data)
                const path = `customers/${isNew ? 'createUser' : 'updateUser'}`
                this.loading = true
                await this.$store.dispatch(path, {
                    customer_id,
                    data,
                })
                if (isNew) {
                    this.doToast('User Created', 'Created', 'success') 
                } else {
                    this.doToast('User Updated', 'Updated', 'success')
                }
                this.$bvModal.hide('modal-customer-user')
            } catch (error) {
                if (error.response) {
                    // Request made and server responded
                    console.log('error.response')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                    this.doToast(
                        'Error Detected',
                        error.response.data.message,
                        'warning'
                    )
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log('error.request')
                    console.log(error.request)
                    this.doToast(
                        'System Error Detected',
                        'Contact Administrator',
                        'warning'
                    )
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message)
                    this.doToast(
                        'System Error Detected',
                        'Contact Administrator',
                        'warning'
                    )
                }
            } finally {
                this.loading = false
            }
        },

        async deleteUser(user_id) {
            try {
                const title = 'Delete Customer?'
                const message = `Are you sure you want to delete the User?`
                const result = await this.confirmMessage(title, message)
                if (!result) throw new Error('Cancel Delete!')

                const { customer_id } = this
                this.loading = true
                await this.$store.dispatch('customers/deleteUser', {
                    customer_id,
                    user_id,
                })
                this.doToast('User Deleted', 'Deleted', 'success')
                this.$bvModal.hide('modal-customer-user')
            } catch (err) {
                console.log('err', err)
                this.doToast('Error Detected', err.message, 'warning')
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
